<template>
  <div class="">
    <h1 class="font-mono text-4xl font-bold">紹介情報<span class="text-gray-400">(工事中)</span></h1>
  </div>
</template>